(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function init() {
      var toggle = document.querySelector('[data-menu-toggle]');
      var menu = document.querySelector('[data-menu]');
      if (!toggle || !menu || toggle.dataset.ready) return;
      toggle.dataset.ready = '1';

      var closeBtn = menu.querySelector('[data-menu-close]');
      var links = Array.prototype.slice.call(menu.querySelectorAll('a'));

      function open() {
        menu.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
      }

      function close(refocus) {
        menu.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        if (refocus) toggle.focus();
      }

      toggle.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', function () { close(true); });

      // Tapping a link navigates; clear the scroll lock so a cached
      // back-navigation doesn't leave the page frozen.
      links.forEach(function (a) {
        a.addEventListener('click', function () { close(false); });
      });

      document.addEventListener('keydown', function (e) {
        if (menu.hidden) return;
        if (e.key === 'Escape') {
          close(true);
          return;
        }
        if (e.key !== 'Tab') return;
        // Keep focus inside the overlay while it covers the page.
        var focusable = [closeBtn].concat(links).filter(Boolean);
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

      // Returning to a wide viewport must not leave the body locked behind a
      // menu that is no longer reachable.
      window.addEventListener('resize', function () {
        if (!menu.hidden && window.innerWidth > 768) close(false);
      });

      window.addEventListener('pageshow', function () {
        if (menu.hidden) document.body.style.overflow = '';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    function initGallery(gallery) {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = '1';

      var root = gallery.closest('.anzee-product') || document;
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
      var main = gallery.querySelector('[data-main]');
      var mainImg = main && main.querySelector('img');
      var box = root.querySelector('[data-lightbox]');
      if (!box) return;

      var boxImg = box.querySelector('[data-lightbox-img]');
      var counter = box.querySelector('[data-count-label]');
      var lastFocus = null;
      var current = 0;

      // With a single image there are no thumbs to read sources from, so fall
      // back to the main image itself.
      var slides = thumbs.length
        ? thumbs.map(function (t) {
            return { src: t.dataset.full, alt: t.dataset.alt || '' };
          })
        : mainImg
          ? [{ src: mainImg.getAttribute('src'), alt: mainImg.getAttribute('alt') || '' }]
          : [];

      if (!slides.length) return;

      function select(i) {
        current = (i + slides.length) % slides.length;
        if (mainImg) {
          mainImg.src = slides[current].src;
          mainImg.alt = slides[current].alt;
        }
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-active', n === current);
        });
        if (main) main.dataset.index = String(current);
      }

      function show(i) {
        current = (i + slides.length) % slides.length;
        boxImg.src = slides[current].src;
        boxImg.alt = slides[current].alt;
        if (counter) counter.textContent = current + 1 + ' / ' + slides.length;
      }

      function open(i) {
        lastFocus = document.activeElement;
        show(i);
        box.hidden = false;
        document.body.style.overflow = 'hidden';
        var close = box.querySelector('[data-close]');
        if (close) close.focus();
      }

      function close() {
        box.hidden = true;
        document.body.style.overflow = '';
        // Release the large source so it isn't held in memory on mobile.
        boxImg.removeAttribute('src');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          // First tap swaps the hero; tapping the already-selected thumb
          // opens the viewer, so one photo is never two taps away.
          if (i === current) open(i);
          else select(i);
        });
      });

      if (main) {
        main.addEventListener('click', function () {
          open(current);
        });
      }

      var closeBtn = box.querySelector('[data-close]');
      if (closeBtn) closeBtn.addEventListener('click', close);

      var prev = box.querySelector('[data-prev]');
      var next = box.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });

      box.addEventListener('click', function (e) {
        if (e.target === box || e.target === boxImg) close();
      });

      document.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') show(current - 1);
        else if (e.key === 'ArrowRight') show(current + 1);
      });

      var startX = null;
      box.addEventListener('touchstart', function (e) {
        startX = e.changedTouches[0].clientX;
      }, { passive: true });

      box.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) show(current + (dx < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });
    }

    function boot() {
      document.querySelectorAll('[data-gallery]').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    // Re-run when the theme editor swaps the section in.
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
